import { injectReducer } from '@ameroservices-platform/loppe-boothownerui/app/store/index';

const withReducer = (key, reducer) => (WrappedComponent) => {
	injectReducer(key, reducer);

	return (props) => <WrappedComponent {...props} />;
};

export default withReducer;
